var map = {
  "./shape-star-aquamarine-gradient.png": "62707",
  "./shape-star-aquamarine-light.png": "841351",
  "./shape-star-aquamarine.png": "512640",
  "./shape-star-blue-gradient.png": "7483",
  "./shape-star-blue-light.png": "819118",
  "./shape-star-blue.png": "689977",
  "./shape-star-cyan-gradient.png": "532306",
  "./shape-star-cyan-light.png": "555690",
  "./shape-star-cyan.png": "593792",
  "./shape-star-green-gradient.png": "56046",
  "./shape-star-green-light.png": "548587",
  "./shape-star-green.png": "787466",
  "./shape-star-grey100.png": "817008",
  "./shape-star-grey1000.png": "215806",
  "./shape-star-grey200.png": "800937",
  "./shape-star-grey25.png": "458648",
  "./shape-star-grey300.png": "992272",
  "./shape-star-grey400.png": "758203",
  "./shape-star-grey50.png": "950152",
  "./shape-star-grey500.png": "850487",
  "./shape-star-grey600.png": "636945",
  "./shape-star-grey700.png": "680145",
  "./shape-star-grey800.png": "380015",
  "./shape-star-grey900.png": "860806",
  "./shape-star-indigo-gradient.png": "338131",
  "./shape-star-indigo-light.png": "608470",
  "./shape-star-indigo.png": "145050",
  "./shape-star-lime-gradient.png": "938987",
  "./shape-star-lime-light.png": "254869",
  "./shape-star-lime.png": "368620",
  "./shape-star-magenta-gradient.png": "719362",
  "./shape-star-magenta-light.png": "881214",
  "./shape-star-magenta.png": "944772",
  "./shape-star-navy-gradient.png": "566235",
  "./shape-star-navy-light.png": "341796",
  "./shape-star-navy.png": "855968",
  "./shape-star-orange-gradient.png": "550038",
  "./shape-star-orange-light.png": "880653",
  "./shape-star-orange.png": "228228",
  "./shape-star-purple-gradient.png": "705257",
  "./shape-star-purple-light.png": "555953",
  "./shape-star-purple.png": "426567",
  "./shape-star-red-gradient.png": "118802",
  "./shape-star-red-light.png": "470342",
  "./shape-star-red.png": "670738",
  "./shape-star-yellow-gradient.png": "128702",
  "./shape-star-yellow-light.png": "642758",
  "./shape-star-yellow.png": "216852"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 456237;
